import { assertIsDefined } from "@artists/devkit"
import type { VotesQuery } from "@artists/gql/design-challenges"

import { AnalyticsPageTitle, createViewListAnalytics } from "../../../../utils"

export const prepareAnalytics = (
	challenge: NonNullable<VotesQuery["challenge"]>,
	challengeEntriesForVoting: VotesQuery["challengeEntriesForVoting"],
) => {
	const {
		results: { entries },
		info: {
			pagination: { offset, limit },
		},
	} = challengeEntriesForVoting

	assertIsDefined(offset)
	assertIsDefined(limit)

	return createViewListAnalytics({
		challenge,
		entries,
		page: { offset, limit, title: AnalyticsPageTitle.Vote },
	})
}
